export const socialServiceOfferGroupFrag = `
  id
  groupId
  validFrom
  validTo
`;
